var map = {
	"./Frame.webp": 355,
	"./arrow.svg": 9,
	"./automation.webp": 921,
	"./bugsquash.webp": 325,
	"./bytecamp.webp": 433,
	"./hoodie.webp": 958,
	"./internxpo.webp": 79,
	"./itinerary.webp": 655,
	"./jio.webp": 756,
	"./me.webp": 736,
	"./pnc.webp": 13,
	"./pormethean.webp": 851,
	"./sieshome.webp": 981,
	"./tea.webp": 52,
	"./techxter.webp": 177,
	"./travellog.webp": 884,
	"./webteam.webp": 201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 320;